import { render, staticRenderFns } from "./PageCheckCompatibility.vue?vue&type=template&id=1b0ad7ec&"
import script from "./PageCheckCompatibility.vue?vue&type=script&lang=js&"
export * from "./PageCheckCompatibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/bluehost-site-migrator/bluehost-site-migrator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0ad7ec')) {
      api.createRecord('1b0ad7ec', component.options)
    } else {
      api.reload('1b0ad7ec', component.options)
    }
    module.hot.accept("./PageCheckCompatibility.vue?vue&type=template&id=1b0ad7ec&", function () {
      api.rerender('1b0ad7ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "source/components/PageCheckCompatibility.vue"
export default component.exports